// extracted by mini-css-extract-plugin
export var infoItem = "_uc-2";
export var title = "_uc-0";
export var value = "_uc-1";